import { ORDER_ST_APPROVAL_ERP_INVOICE_API_URL } from "../components/Shared/constant";

const OrderErpInvoice = async (accessToken, order_id, booleanValue) => {
    const responce = window.axios.get(`${ORDER_ST_APPROVAL_ERP_INVOICE_API_URL}/${order_id}/${booleanValue}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default OrderErpInvoice;